export class FullNameAttribute {
    public static hasError(value: string): boolean {
        var fullname = value.split(" ")
        if (!value || fullname.length <= 1 || fullname[1].length < 1) {
            return true;
        }
        return false;
    }

    public static getErrorMessage(): string {
        return "Indtast dit fulde navn";
    }
}
